var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"color":"white","opacity":"0.5","value":_vm.isLoading}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"128"}},[_c('v-img',{attrs:{"src":require('@/assets/images/company-logo.svg'),"width":"96","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }